import {
  View,
  Text,
  TextInput,
  ActivityIndicator
} from 'react-native'
import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view'
import * as yup from 'yup'
import { useFormsStore } from "../../../../stores/onboarding"
import { useInitializeStore } from '../../../../stores/initialize'
import { usePersonalStore } from '../../../../stores/personalInfo'
import { globalStyles } from '../../../../static/styles/global'
import HomeDetailsHeader from '../../../home/HomeDetailsHeader'
import { Formik } from 'formik'
import Toast from 'react-native-toast-message'
import Card from '../../../shared/card/Card'
import CustomButton from '../../../shared/button/Button'

const HandBookSignOffForm = ({ navigation, route }): JSX.Element => {
    const { params } = route
    const {
        mostRecentUserOnBoardings: userId,
        mode,
        essUserOnBoardingKey,
        essUserOnBoardingFormKey
    } = params
    const intialValues = {
        initials: ""
    }
    const alschema = yup.object({
        initials: yup.string().required("Initials is a required field")
    })
    const { loading, postHandBookSignOff } = useFormsStore()
    const initializestore = useInitializeStore()
    const personalstore = usePersonalStore()
    return (
        <KeyboardAwareScrollView
      enableOnAndroid={true}
      enableAutomaticScroll={true}
      enableResetScrollToCoords={false}
      keyboardShouldPersistTaps="handled"
      keyboardDismissMode="interactive"
      showsVerticalScrollIndicator={false}
      extraScrollHeight={80}
      contentContainerStyle={{ flexGrow: 1, paddingBottom: 20 }}
    >
            <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
                <View style={[globalStyles.horizontalPadGap]}>
                    <HomeDetailsHeader
                        navLabel="Forms"
                        navScreen="OnboardingForms"
                        title={'JProuxl Handbook'}
                    />
                </View>
            </View>
            <View style={globalStyles.containerOverlap}>
                <Formik
                    initialValues={{ ...intialValues }}
                    validationSchema={alschema}
                    onSubmit={async (values, actions) => {
                        if (mode === 'upload') {
                            const data = {
                                completeOnline: false,
                                essUserKey: initializestore.initializeData.userkey,
                                entityId: personalstore.personalData?.entityId,
                                essUserOnBoardingFormKey: essUserOnBoardingFormKey,
                                essObKey: essUserOnBoardingKey,
                                initials: values?.initials?.toUpperCase()
                            }
                            const response = await postHandBookSignOff(data)
                            if (response?.success) {
                                await Toast.show({
                                    type: 'success',
                                    position: 'bottom',
                                    text1: response?.message,
                                    visibilityTime: 3000,
                                    autoHide: true,
                                    topOffset: 60,
                                    onHide: () => {
                                        navigation.replace('OnboardingForms')
                                    }
                                })
                            }
                            else {
                                await Toast.show({
                                    type: 'error',
                                    position: 'bottom',
                                    text1: response?.message,
                                    visibilityTime: 3000,
                                    autoHide: true,
                                    topOffset: 60
                                })
                            }
                        } else {
                            navigation.navigate('HandBookSignOffOnline', {
                                userId,
                                mode,
                                essUserOnBoardingKey,
                                essUserOnBoardingFormKey,
                                values,
                            })
                        }
                    }}
                >
                    {(props) => (
                        <>
                            <Card>
                                <View
                                    style={[
                                        globalStyles.hDirection,
                                        globalStyles.hBetweenItems,
                                        globalStyles.mb2
                                    ]}
                                >
                                    <View style={{ justifyContent: 'center', width: '50%' }}>
                                        <Text
                                            style={[
                                                globalStyles.inputLabel,
                                                globalStyles.inputLabelLarge,
                                                globalStyles.inputLabelPrimary
                                            ]}
                                        >
                                            {'Please add your initials *'}
                                        </Text>
                                    </View>
                                    <View style={{ width: '28%', overflow: 'hidden' }}>
                                        <TextInput
                                            style={[globalStyles.input, globalStyles.inputLight]}
                                            value={props.values.initials}
                                            onChangeText={(text) => {
                                                props.handleChange('initials')(text)
                                            }}
                                        />
                                        {props.touched.initials &&
                                            props.errors.initials && (
                                                <Text style={globalStyles.dangerAlert}>
                                                    {props.errors.initials as string}
                                                </Text>
                                            )}
                                    </View>
                                </View>
                                {loading ? (
                                    <ActivityIndicator />
                                ) : (
                                    <View style={{ margin: 10 }}>
                                        <CustomButton
                                            text={mode === 'upload' ? 'Submit Information' : 'Next'}
                                            onPress={props.handleSubmit}
                                        />
                                    </View>
                                )}
                            </Card>
                        </>
                    )}
                </Formik>
            </View>

        </KeyboardAwareScrollView>
    )
}
export default HandBookSignOffForm
